import * as React from 'react'
import PropTypes from 'prop-types'

import Button from '../../components/atoms/Button/Button'
import ImageAsset, { ImageAssetType } from '../../components/atoms/ImageAsset/ImageAsset'
import Logo, { LogoType } from '../../components/atoms/Logo/Logo'
import AuthForm, { FormType } from '../../components/organisms/AuthForm/AuthForm'

import './LoginPage.css'
import { POST_LOGIN, CHANGE_LOGIN_FORM } from '../../actions/authActions'
import { connect } from 'react-redux'
import CommonFooter from '../../components/organisms/CommonFooter/CommonFooter'
import InnerLink, { InnerLinkType } from '../../components/atoms/InnerLink/InnerLink'

const LoginPage = ({ email, password, isLoading, error, handleChangeForm, handleLogin }) => {
  return (
    <div styleName="background">
      <div styleName="container">
        <div styleName="backgroudImage">
          <ImageAsset type={ImageAssetType.TOP_VISUAL} />
        </div>
        <div styleName="mainContent">
          <div styleName="titlePart">
            <div styleName="logo">
              <Logo type={LogoType.GRAY} />
            </div>
            <h1 styleName="title">ログイン</h1>
          </div>
          <div>
            <AuthForm
              type={FormType.LOGIN}
              email={email}
              password={password}
              handleChangeForm={handleChangeForm}
              errors={{ password: error }}
            />

            <div styleName="signupLink">
              <InnerLink to="/signup" type={InnerLinkType.NORMAL}>
                <p styleName="text">会員登録したい方はこちら</p>
              </InnerLink>
            </div>
            <div styleName="forgetLink">
              <InnerLink to="/password_reset/email" type={InnerLinkType.NORMAL}>
                <p styleName="text">パスワードを忘れた方はこちら</p>
              </InnerLink>
            </div>
            <div styleName="button">
              <Button handleClick={() => handleLogin({ email, password })} isLoading={isLoading}>
                ログイン
              </Button>
            </div>
          </div>
        </div>
      </div>
      <CommonFooter />
    </div>
  )
}

LoginPage.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  handleChangeForm: PropTypes.func.isRequired,
  handleLogin: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  email: state.auth.loginEmail,
  password: state.auth.loginPassword,
  isLoading: state.auth.isLoginLoading,
  error: state.auth.loginError
})

const mapDispatchToProps = dispatch => ({
  handleLogin: data => dispatch(POST_LOGIN(data)),
  handleChangeForm: data => dispatch(CHANGE_LOGIN_FORM(data))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPage)
